export const environment = {
  production: true,
  strapiBaseUrl: 'https://gorgeous-laughter-7126de9a27.strapiapp.com',
};
